import { takeLatest, call } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { movieOrderSelector } from "./helpers"
import { reorderListAndFractal } from "./helpers/updateOrderListAndFractal"
import getData from "../../functions/getData"
import { PROGRAM_MOVIEMAPPING_ITEMS, PROGRAM_PM_MOVIES_ITEMS } from "../../constants/state"

const pmMovieItemOrderSelector = (state, pk) => {
    const pmMoviePk = getData(state, [PROGRAM_MOVIEMAPPING_ITEMS, pk, 'pm'])
    return getData(state, [PROGRAM_PM_MOVIES_ITEMS, pmMoviePk, 'order'])
}

function* updateOrder({payload}) {
    const { oldIndex, newIndex } = yield payload

    yield call(reorderListAndFractal, oldIndex, newIndex, actionTypes.CLIMOVIES_UPDATE_ORDER, actionTypes.PMMOVIES_UPDATE_ITEM_ORDER, movieOrderSelector, pmMovieItemOrderSelector)
}

export function* watchUpdateMovieOrder() {
    try {
        yield takeLatest(actionTypes.MOVIES_UPDATE_ORDER_REQUEST, updateOrder)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}